import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-white/[0.03] select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-white">Page Not Found</h1>
        <p className="mt-2 text-base text-white/40 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-white/30">This page does not exist. Go back to the home page.</p>
        <a href="/" className="inline-flex items-center justify-center gap-2 mt-6 bg-boxing-red text-white px-6 py-3 rounded-full font-oswald uppercase tracking-wider text-sm font-bold transition-all duration-300 hover:scale-105 whitespace-nowrap">
          <i className="ri-arrow-left-line" />
          Back to Home
        </a>
      </div>
    </div>
  );
}